import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=57a73bde&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=57a73bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a73bde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57a73bde')) {
      api.createRecord('57a73bde', component.options)
    } else {
      api.reload('57a73bde', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=57a73bde&scoped=true&", function () {
      api.rerender('57a73bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tN0fvhRuTzZD/JS/comp/GuestBox.vue"
export default component.exports